import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=5bf0839e&scoped=true&"
import script from "./ChatDialog.vue?vue&type=script&lang=js&"
export * from "./ChatDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatDialog.scss?vue&type=style&index=0&id=5bf0839e&prod&lang=scss&scoped=true&"
import style1 from "./ChatDialog.vue?vue&type=style&index=1&id=5bf0839e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0839e",
  null
  
)

export default component.exports